import addIbanSchemas from "@rentiohq/shared-frontend/dist/forms/addIban";
import * as addIbanActions from "@rentiohq/shared-frontend/dist/forms/addIban/schema.addIban.actions";
import * as authSelectors from "@rentiohq/shared-frontend/dist/redux/auth/auth.selectors";
import { getName } from "@rentiohq/shared-frontend/dist/redux/contact/contact.utils";
import { createForm } from "@rentiohq/shared-frontend/dist/redux/form/form.actions";
import { generateFormId } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import queryString from "query-string";
import { default as React } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router";
import { IRootState } from "redux/reducers";
import FormMultistep from "../../../../components/FormMultistep";
import InfoHeader from "../../../../components/InfoHeader";
import Page from "../../../../components/Page";
import withAuthenticationCheck from "../../../../hoc/withAuthenticationCheck";
import withKycRequired from "../../../../hoc/withKycRequired";
import { getReferrer } from "../../../../utils/navigation.utils";
import PaymentRequestRedirect from "../../components/PaymentRequestRedirect";
import * as S from "./MangopayAddIban.styles";

const MangopayAddIbanBase = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams<{ paymentRequestId?: string }>();

  const [formId] = React.useState(generateFormId());
  const user = useSelector((state: IRootState) => authSelectors.getUser(state));

  // Lifecycle
  React.useEffect(() => {
    dispatch(
      createForm({
        formId: formId,
        schemas: addIbanSchemas({
          showHeader: false,
          ownerName: user ? getName(user) : undefined,
        }),
        withSummary: false,
      }),
    );
  }, []);

  // Event handlers
  const handleCustomSuccessAction = (ibanId?: number) => {
    if (!ibanId) {
      return;
    }

    const referrerPath = queryString.parseUrl(getReferrer(location));
    referrerPath.query.ibanId = `${ibanId}`;

    const resultPath = queryString.stringifyUrl(referrerPath);

    navigate(resultPath);
  };

  // Helpers
  const paymentRequestId = params.paymentRequestId
    ? parseInt(params.paymentRequestId, 0)
    : undefined;

  // Render
  if (!user) {
    return;
  }

  if (!paymentRequestId) {
    return null;
  }

  return (
    <>
      <PaymentRequestRedirect id={paymentRequestId} />
      <Page>
        <InfoHeader
          title={getLocalizedText("payment.online.title.add_iban")}
          body={getLocalizedText("payment.online.body.add_iban")}
        />
        <S.FormWrap>
          <FormMultistep
            formId={formId}
            // @ts-ignore state match
            isPerformingSubmitActionSelector={addIbanActions.isPerformingSubmitActionSelector()}
            // @ts-ignore state match
            performingSubmitActionResultSelector={addIbanActions.performingSubmitActionResultSelector(
              undefined,
              user.personalContactId,
            )}
            // @ts-ignore state match
            performingSubmitActionErrorSelector={addIbanActions.performingSubmitActionErrorSelector()}
            submitActionCreator={addIbanActions.submitActionCreator(
              undefined,
              user.personalContactId,
            )}
            customSuccessAction={handleCustomSuccessAction}
            submitTitle={getLocalizedText("payment_add_iban.other.cta")}
          />
        </S.FormWrap>
      </Page>
    </>
  );
};

export const MangopayAddIban = withAuthenticationCheck(
  withKycRequired(MangopayAddIbanBase),
);
